import React, { Component } from 'react'
import Lottie from 'react-lottie'
// import animationData from '../lotties/4203-take-a-selfie.json'
import { PropTypes } from 'prop-types';

class UncontrolledLottie extends Component {
  constructor(props) {
    super(props);
  }

  render() {

    const defaultOptions = {
      loop: true,
      autoplay: true, 
      animationData: this.props.animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };

    return(
      <div className={this.props.className}>
        {/* <h1>Lottie</h1>
        <p>Base animation free from external manipulation</p> */}
          <Lottie 
            isClickToPauseDisabled = {true}
            options={defaultOptions}
            height={this.props.height}
            width={this.props.width}
          />
      </div>
    )
  }
}

UncontrolledLottie.propTypes = {
  animationData: PropTypes.object,
  className: PropTypes.any,
  height: PropTypes.any,
  width: PropTypes.any
}

export default UncontrolledLottie